export const Colors = {
  primary: "#48B866",
  primary75: "#76ca8c",
  primary50: "#a4dcb3",
  primary25: "#d1edd9",
  primary15: "#e4f4e8",
  primary10: "#edf8f0",
  primary05: "#f6fbf7",
  primary01: "#fdfefd",
  black: "#000000",
  white: "#FFFFFF",
  warning: "#FE8F00",
  danger: "#E13C31",
  info: "#23A7DF",
  success: "#00A550",
  dark: "#000000",
  dark75: "#404040",
  dark50: "#808080",
  dark25: "#BFBFBF",
  dark15: "#D9D9D9",
  dark10: "#E5E5E5",
  dark05: "#F2F2F2",
  dark01: "#FDFDFD",
  muted: "#BFBFBF",
};
